// eslint-disable-next-line import/prefer-default-export
export const GET_JOB_PHASES = 'JobPhasesModule/GET_JOB_PHASES';
